import { render, staticRenderFns } from "./StaffPermissions.vue?vue&type=template&id=3190bec3&"
import script from "./StaffPermissions.vue?vue&type=script&lang=js&"
export * from "./StaffPermissions.vue?vue&type=script&lang=js&"
import style0 from "./StaffPermissions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports